import React, { useEffect } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Typography } from "@mui/material";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnCancel, BtnConfirm, BtnSend } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import { WiTime9 } from "react-icons/wi";
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertTitle, AlertTitleTh, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { useLocation, useNavigate } from 'react-router-dom';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { i18n } from 'i18n';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nField = 'entities.ModalReject.fields';
const i18nFieldCommon = "common";
const ModalReject = (props) => {

    const {
        IsOpen,
        setIsOpen,
        sVOCFormID,
        setIsOpenSnackbar,
        setsSeveritySnackbar,
        setsMessageSnackbar,
        sMaxWidth = "md",
    } = props;

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const navigate = useNavigate();

    const schema = yup.object().shape({
        sReason: yupFormSchemas.string(i18n(`${i18nField}.sReason`), { required: true }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    useEffect(() => {
        if (IsOpen == true) {
            form.setValue("sReason", null)
            form.clearErrors();
        }
    }, [IsOpen])

    const onSubmitReject = () => {
        let param = {
            "sVOCFormID": sVOCFormID,
            "sMode": "RE",
            "sRemark": form.getValues("sReason") ?? null
            
        }
        let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะไม่ยอมรับการแก้ไขใช่หรือไม่ ?" : "Do you want to reject data ?"

        SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
            setIsOpen(false)
            BlockUI();

            AxiosPost(`VOC/SaveVOCFormData`, param, (res) => {
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                        setsSeveritySnackbar("success")
                        setTimeout(() => {
                            UnBlockUI();
                            navigate("/Front/MyVOC")
                        }, 2000)
                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")
                        UnBlockUI();

                    }
                })
            }, null, null)
        })
    }

    return (
        <Dialog
            open={IsOpen}
            onClose={() => { setIsOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={sMaxWidth}
        >
            <DialogTitle>{i18n(`${i18nField}.sPleasegiveareason`)}</DialogTitle>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogContent>
                <FormProvider {...form}>
                    <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center">
                        <Grid item xs={12}>
                            <InputCustomLabel
                                id="sReason"
                                name="sReason"
                                label={i18n(`${i18nField}.sReason`)}
                                required={true}
                                multiline={true}
                                maxLength={1000}
                                rows={4}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </FormProvider>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1} direction="row" justifyContent="end" alignItems="center" >
                    <Grid item>
                        <BtnConfirm txt={i18n(`${i18nFieldCommon}.btnConfirm`)} onClick={form.handleSubmit(() => { onSubmitReject() })} />
                    </Grid>
                    <Grid item>
                        <BtnCancel txt={i18n(`${i18nFieldCommon}.cancel`)} onClick={() => { setIsOpen(false) }} />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ModalReject